export default function secondsToTimeFormat(seconds) {
  if (isNaN(seconds) || seconds < 0) {
    return "0:00:00";
  }

  const hours = Math.floor(seconds / 3600); 
  const minutes = Math.floor((seconds % 3600) / 60); 
  const remainingSeconds = seconds % 60;

  const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;

  return formattedTime;
}
